class BuildTags {
}
/** Hash the last time inertia was built */
BuildTags.buildHash = '435ebc75';
/** Version of the package.json file the last time inertia was built */
BuildTags.packageVersion = '1140.0.3';
/** Time inertia was built in UTC */
BuildTags.buildTime = 'Wed, 26 Nov 2025 07:07:00 GMT';
/** Time inertia was built in Boston time */
BuildTags.buildTimeBoston = '2025-11-26 02:06:35 Boston';
/** Detailed build tags string */
BuildTags.detailed = 'BuildTags: 2025-11-26 02:06:35 Boston - 435ebc75 - 1140.0.3';
export default BuildTags;
